






























import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({
	name: 'ImageUploadItem',
})
export default class ImageUploadItem extends Vue {
	@Prop({})
	private name!: string

	@Prop({})
	private type!: string

	@Prop({})
	private images?: any[] // 已上传成功的文件对象

	@Prop({ default: false })
	private isReadonly!: boolean

	private get imageList() {
		if (this.images && this.images.length > 0) {
			return this.images
		} else {
			// 只读时若某类图片不存在则不展示
			return this.isReadonly ? [] : [{}]
		}
	}

	private addPic() {
		this.$emit('addPic', this.type)
	}

	private reupload(index: number) {
		this.$emit('reuploadPic', { type: this.type, index })
	}

	private handleRemove(image: any) {
		this.$emit('removePic', { type: this.type, picId: image.picId })
	}

	private handlePreview(e: any) {
		// e.target为svg,svg->i->img-actions->img-wrapper
		let target = e.target.parentNode.parentNode.parentNode
		if (e.target.nodeName === 'path') {
			target = target.parentNode
		}
		const dom: any = target.querySelector('img')
		if (dom) {
			dom.click()
		}
	}
}
